// API helpers for working with markers and maps

const API_URL = process.env.REACT_APP_API_URL || "";

export function getMarkersForMapFromBackend(mapKey) {
  return fetch(`${API_URL}/api/coords?map=${encodeURIComponent(mapKey)}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      return data.markers || [];
    });
}

export async function saveAllMarkersToBackend(mapKey, markers) {
  const res = await fetch(`${API_URL}/api/coords`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ map: mapKey, markers }),
  });
  if (!res.ok) throw new Error("Error saving markers to backend!");
  const data = await res.json();
  return data.markers || markers;
}

// Dohvati original marker iz backenda po id-u i mapi
export async function getOriginalMarkerFromBackend(mapKey, markerId) {
  const markers = await getMarkersForMapFromBackend(mapKey);
  return markers.find((m) => m.id === markerId);
}

export async function saveMarkerNamesToBackend(mapKey, names) {
  const res = await fetch(`${API_URL}/api/markernames`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ map: mapKey, names }),
  });
  if (!res.ok) throw new Error("Error saving marker names to backend!");
  const data = await res.json();
  return data;
}
